const configuration = {
    rest: 'https://test.externe-dokumentation.de',
    status: {
        created: 201,
        ok: 200
    },
    reportingYear: 2024
}

export default configuration;